module.exports = __webpack_public_path__ + "img/1.b242065a.jpg";